/**
 * @format
 */

import { api } from '@/scripts/api';

export const DocumentCustomTagsService = {
    post(payload){
        return new Promise((resolve, reject) => {
            const service = '/api/DocumentCustomTags'
            
            api.post(service, payload)
                .then(resolve)
                .catch(reject)
        })
    },

    patch(tagId, payload){
        return new Promise((resolve, reject) => {
            const service = `/api/DocumentCustomTags/${tagId}`
            
            api.patch(service, payload)
                .then(resolve)
                .catch(reject)
        })
    },

    delete(tagId){
        return new Promise((resolve, reject) => {
            const service = `/api/DocumentCustomTags/${tagId}`
            
            api.delete(service)
                .then(resolve)
                .catch(reject)
        })
    }
}